import { faCircle } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Unchecked radio button icon.
 * @returns Icon.
 */
const UncheckedIcon = () => (
    <FontAwesomeIcon aria-label="radio-unchecked-icon" fixedWidth={true} icon={faCircle} size="lg" />
);

export default UncheckedIcon;
